import useGetCustomersByIds from './useGetCustomersByIds'

export default useGetCustomersByIds
